import * as React from "react"

const X = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="M9.146 7.214 13.632 2h-1.063L8.674 6.527 5.564 2H1.975L6.68 8.846l-4.704 5.468h1.063l4.113-4.781 3.285 4.78h3.588L9.146 7.215ZM7.69 8.906l-.476-.681L3.422 2.8h1.632l3.06 4.378.477.682 3.978 5.69h-1.632L7.69 8.907Z" />
  </svg>
)

export default X
